<template>
  <div class="service-widget" :class="{ open: isOpen }">
    <button
      type="button"
      class="service-fab"
      aria-label="打开客服"
      @click="isOpen = !isOpen"
    >
      <span>客服</span>
    </button>

    <section class="service-panel" v-if="isOpen">
      <header class="service-header">
        <div>
          <strong>在线客服</strong>
          <span>有问题请直接联系人工客服</span>
        </div>
        <button type="button" aria-label="关闭客服" @click="isOpen = false">×</button>
      </header>

      <div class="message-list" ref="messageList">
        <div
          v-for="message in messages"
          :key="message.id"
          class="message-row"
          :class="message.from"
        >
          <div class="message-bubble">{{ message.text }}</div>
        </div>
      </div>

      <form class="service-input" @submit.prevent="sendMessage">
        <input v-model.trim="question" type="text" placeholder="请输入问题">
        <button type="submit">发送</button>
      </form>
    </section>
  </div>
</template>

<script>
const contactReply = '您好，请联系客服：15311160987'

export default {
  name: 'CustomerServiceChat',
  data() {
    return {
      isOpen: false,
      question: '',
      messages: [
        {
          id: 1,
          from: 'bot',
          text: contactReply
        }
      ]
    }
  },
  methods: {
    sendMessage() {
      if (!this.question) {
        this.pushBotReply()
        return
      }

      this.messages.push({
        id: Date.now(),
        from: 'user',
        text: this.question
      })
      this.question = ''
      this.pushBotReply()
    },
    pushBotReply() {
      this.messages.push({
        id: Date.now() + 1,
        from: 'bot',
        text: contactReply
      })
      this.$nextTick(() => {
        if (this.$refs.messageList) {
          this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight
        }
      })
    }
  }
}
</script>

<style scoped>
.service-widget {
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 880;
  color: #eef3ff;
}

.service-fab {
  width: 62px;
  height: 62px;
  border: 0;
  border-radius: 50%;
  color: #07101d;
  font-weight: 900;
  cursor: pointer;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.36), 0 0 0 8px rgba(35, 211, 238, 0.1);
}

.service-fab span {
  display: block;
  font-size: 14px;
}

.service-panel {
  position: absolute;
  right: 0;
  bottom: 78px;
  width: min(360px, calc(100vw - 32px));
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: linear-gradient(180deg, rgba(20, 24, 39, 0.98), rgba(10, 13, 24, 0.98));
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.42);
}

.service-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.service-header strong {
  display: block;
  color: #f5f7ff;
  font-size: 16px;
}

.service-header span {
  display: block;
  margin-top: 4px;
  color: #9faaca;
  font-size: 12px;
}

.service-header button {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  color: #dfe7ff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.08);
}

.message-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 260px;
  overflow-y: auto;
  padding: 16px;
  background: rgba(5, 8, 16, 0.5);
}

.message-row {
  display: flex;
}

.message-row.user {
  justify-content: flex-end;
}

.message-bubble {
  max-width: 82%;
  padding: 11px 13px;
  border-radius: 8px;
  color: #dfe7ff;
  line-height: 1.6;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.08);
}

.message-row.user .message-bubble {
  color: #07101d;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.service-input {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 70px;
  gap: 10px;
  padding: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.service-input input {
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 11px 12px;
  color: #eef3ff;
  outline: none;
  background: rgba(7, 10, 18, 0.82);
}

.service-input input:focus {
  border-color: #23d3ee;
  box-shadow: 0 0 0 4px rgba(35, 211, 238, 0.12);
}

.service-input button {
  border: 0;
  border-radius: 8px;
  color: #07101d;
  font-weight: 900;
  cursor: pointer;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

@media (max-width: 720px) {
  .service-widget {
    right: 14px;
    bottom: 14px;
  }

  .service-fab {
    width: 56px;
    height: 56px;
  }
}
</style>
